import * as React						from 'react';
import { Outlet, useNavigate }			from "react-router";

import Menu								from '@mui/joy/Menu';
import MenuButton 						from '@mui/joy/MenuButton';
import IconButton						from '@mui/joy/IconButton';
import Typography						from '@mui/joy/Typography';
import MenuItem							from '@mui/joy/MenuItem';
import Dropdown 						from '@mui/joy/Dropdown';
import ListDivider 						from '@mui/joy/ListDivider';

import IcoAddCircleOutlineRoundedIcon	from '@mui/icons-material/AddCircleOutlineRounded';
import IcoContentCutIcon 				from '@mui/icons-material/ContentCut';
import IcoSettingsRoundedIcon			from '@mui/icons-material/SettingsRounded';
import IcoBurgerIcon					from '@mui/icons-material/Menu';
import IcoLogoutOutlinedIcon 			from '@mui/icons-material/LogoutOutlined';

export default function AppLayout() {
	const navigate = useNavigate();
	
	const handleNewStop = () => {
		navigate('/addticker');
	};

	const handleShowStops = () => {
		navigate('/showstops');			
	};		

	const handleProfile = () => {
		navigate('/profile');
	};		

	const handleLogout = () => {
		let logoutOK = localStorage.getItem("usercreated");

		if (logoutOK == "" || logoutOK == null)
			logoutOK = false;

		if (logoutOK) {
			console.log("User created -> allow logout");
			localStorage.setItem("username", "");
			navigate('/');
		}
		else {
			console.log("User not created -> prevent logout and goto profile");
			// user profile not saved, goto profile to save email/mobile
			navigate('/profile');
		}
	};	
	
	return (
		
		<Dropdown>
		
			<MenuButton slots={{ root: IconButton }} slotProps={{ root: { variant: 'plain', color: 'success', size: 'lg' } }}>
				<IcoBurgerIcon />
			</MenuButton>
			
			<Menu size="lg" placement="right-end">
			
				<MenuItem onClick={handleShowStops}> <Typography fontSize="lg" startDecorator={<IcoContentCutIcon color='success'/>}>My stops</Typography></MenuItem>
				<MenuItem onClick={handleNewStop}>   <Typography fontSize="lg" startDecorator={<IcoAddCircleOutlineRoundedIcon color='success'/>}>New stop...</Typography></MenuItem>
				<MenuItem onClick={handleProfile}>   <Typography fontSize="lg" startDecorator={<IcoSettingsRoundedIcon color='success'/>}>Profile</Typography></MenuItem>
				
				<ListDivider />

				<MenuItem onClick={handleLogout}>   <Typography fontSize="sm" startDecorator={<IcoLogoutOutlinedIcon color='neutral'/>}>Logout</Typography></MenuItem>					
			</Menu>					
			
			<Outlet />
		
		</Dropdown>			

	);
}